import React from 'react'
import { Extra, ExtraTarifa, GrupoTarifa, Pago, ReservaTarifa, Tarifa, TiposAlojamientos, TiposExtras } from 'src/gql/schema'
import ExtraDetail from '../ExtraDetail/ExtraDetail'

const buildExtrasFromReservaTarifas = (
    extra: Extra,
    reservas_tarifas: ReservaTarifa[]
): { tarifa: Tarifa; grupoTarifa: GrupoTarifa; extraTarifa: ExtraTarifa }[] => {
    const groups = new Map<string, { rt: ReservaTarifa; noches: number }>()

    for (const rt of reservas_tarifas) {
        const key = rt.tarifa?.grupo_tarifa_id || rt.tarifa_id
        if (!key) continue
        const existing = groups.get(key)
        if (existing) {
            existing.noches += rt.subtotales?.noches || 0
        } else {
            groups.set(key, { rt, noches: rt.subtotales?.noches || 0 })
        }
    }

    return Array.from(groups.values()).map(({ rt, noches }) => {
        const costoUnitario =
            extra.tipo_extra === TiposExtras.Persona
                ? rt.tarifa?.costo_persona_extra || 0
                : extra.tipo_extra === TiposExtras.Hora
                    ? rt.tarifa?.costo_hora_extra || 0
                    : rt.tarifa?.costo_hospedaje_extra || 0

        const totalNoches = extra.tipo_extra === TiposExtras.Hora ? 1 : noches
        const total = costoUnitario * (extra.numero || 1) * totalNoches

        return {
            tarifa: rt.tarifa as Tarifa,
            grupoTarifa: rt.tarifa?.grupo_tarifa as GrupoTarifa,
            extraTarifa: {
                subtotales: { total, precio_unitario: costoUnitario, numero: extra.numero || 1 },
            } as ExtraTarifa,
        }
    })
}

const ExtraDetailList = ({
    extras,
    fechas_renta,
    pagos,
    tipo_hospedaje,
    reservas_tarifas = [],
}: {
    extras: Extra[]
    fechas_renta: { fecha_registro: string; fecha_condensada: string }
    pagos: Pago[]
    tipo_hospedaje: TiposAlojamientos
    reservas_tarifas?: ReservaTarifa[]
}) => {

    return (
        !!extras.length &&
        !!pagos.length &&
        extras.map((e, index) => {
            const pagoExtra = pagos.find((p) =>
                p.extras?.some((extra) => extra.extra_id === e.extra_id)
            )

            if (!pagoExtra) return null

            const tarifas = e.extras_tarifas || []

            if (tarifas.length === 0) {
                return buildExtrasFromReservaTarifas(e, reservas_tarifas).map(
                    ({ tarifa, grupoTarifa, extraTarifa }, t_index) => (
                        <ExtraDetail
                            tipo_hospedaje={tipo_hospedaje}
                            key={`${index}-reserva-${t_index}`}
                            extra={e}
                            fechas_renta={fechas_renta}
                            grupoTarifa={grupoTarifa}
                            pago={pagoExtra as Pago}
                            tarifa={tarifa}
                            extraTarifa={extraTarifa}
                            cantidadHospedajeExtra={e.numero}
                        />
                    )
                )
            }

            return tarifas.map((et, t_index) => (
                <ExtraDetail
                    tipo_hospedaje={tipo_hospedaje}
                    key={`${index}-${t_index}`}
                    extra={e}
                    fechas_renta={fechas_renta}
                    grupoTarifa={et.tarifa?.grupo_tarifa as GrupoTarifa}
                    pago={pagoExtra as Pago}
                    tarifa={et.tarifa as Tarifa}
                    extraTarifa={et as ExtraTarifa}
                    cantidadHospedajeExtra={e.numero}
                />
            ))
        })
    )
}

export default ExtraDetailList
